import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { Link } from 'react-router-dom';

const services = [
  {
    en: 'Call Center Management',
    title: 'コールセンター企画・運営・管理',
    icon: 'ri-headphone-line',
    desc: 'コールセンターの立ち上げ企画から日常運営、品質管理まで一貫してサポートします。お客様の声を大切にした顧客対応体制を構築し、継続的な改善を行います。',
    features: ['コールセンター立ち上げ支援', 'オペレーター採用・教育', '品質管理・モニタリング', 'KPI設定・管理', 'システム導入支援'],
  },
  {
    en: 'Business Outsourcing',
    title: '業務委託サービス',
    icon: 'ri-briefcase-line',
    desc: 'バックオフィス業務・データ入力・各種事務処理など、幅広い業務を受託します。コア業務への集中をサポートし、業務効率化を実現します。',
    features: ['バックオフィス業務全般', 'データ入力・管理', '書類作成・整理', '各種事務処理代行', '業務フロー設計'],
  },
  {
    en: 'Customer Support',
    title: 'カスタマーサポート代行',
    icon: 'ri-customer-service-2-line',
    desc: '電話・メール・チャットによる顧客対応を代行します。専門スタッフが丁寧かつ迅速に対応し、顧客満足度向上に貢献します。',
    features: ['電話対応代行', 'メール対応代行', 'チャットサポート', 'クレーム対応', '多言語対応（要相談）'],
  },
  {
    en: 'Process Consulting',
    title: '業務プロセスコンサルティング',
    icon: 'ri-line-chart-line',
    desc: '業務フローの分析・改善提案から実行支援まで。現場に寄り添ったコンサルティングで、組織の生産性向上を実現します。',
    features: ['業務フロー分析', '改善提案・実行支援', 'コスト削減施策', 'DX推進支援', '定期レビュー・報告'],
  },
];

export default function ServicesPage() {
  return (
    <>
      <Navbar />
      <main className="bg-white min-h-screen">
        {/* Hero */}
        <section className="relative bg-[#0f1628] geo-pattern pt-32 pb-20">
          <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10">
            <span className="font-cormorant text-[#c9a84c] text-sm tracking-[0.4em] uppercase block mb-3">Services</span>
            <h1 className="font-serif-jp text-white text-4xl md:text-5xl tracking-wider font-medium mb-4">サービス紹介</h1>
            <div className="flex items-center gap-3">
              <div className="w-12 h-px bg-[#c9a84c]"></div>
              <div className="w-1.5 h-1.5 bg-[#c9a84c] rotate-45"></div>
            </div>
          </div>
        </section>

        {/* Services */}
        <section className="py-20 md:py-28">
          <div className="max-w-7xl mx-auto px-6 md:px-10">
            <div className="flex flex-col gap-16">
              {services.map((svc, i) => (
                <div key={svc.en} className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${i % 2 === 1 ? 'lg:flex-row-reverse' : ''}`}>
                  <div className={i % 2 === 1 ? 'lg:order-2' : ''}>
                    <div className="w-10 h-10 flex items-center justify-center mb-4">
                      <i className={`${svc.icon} text-3xl text-[#c9a84c]`}></i>
                    </div>
                    <span className="font-cormorant text-[#c9a84c]/60 text-xs tracking-[0.3em] uppercase block mb-2">{svc.en}</span>
                    <h2 className="font-serif-jp text-[#0f1628] text-2xl md:text-3xl tracking-wider font-medium mb-4">{svc.title}</h2>
                    <div className="w-10 h-px bg-[#c9a84c] mb-6"></div>
                    <p className="text-[#0f1628]/60 text-sm leading-relaxed font-sans mb-8">{svc.desc}</p>
                    <ul className="flex flex-col gap-2">
                      {svc.features.map((f) => (
                        <li key={f} className="flex items-center gap-3 text-[#0f1628]/70 text-sm font-sans">
                          <i className="ri-check-line text-[#c9a84c]"></i>{f}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className={`relative ${i % 2 === 1 ? 'lg:order-1' : ''}`}>
                    <img
                      src={`https://readdy.ai/api/search-image?query=abstract%20geometric%20corporate%20art%20with%20dark%20navy%20and%20gold%20tones%2C%20minimalist%20business%20visual%2C%20angular%20shapes%20and%20lines%2C%20professional%20atmosphere%2C%20no%20people%2C%20pure%20abstract%20design%20number%20$%7Bi%20%20%201%7D&width=600&height=400&seq=svc00${i + 1}&orientation=landscape`}
                      alt={svc.title}
                      className="w-full h-64 md:h-80 object-cover object-top"
                    />
                    <div className="absolute -bottom-3 -right-3 w-16 h-16 border border-[#c9a84c]/30"></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="bg-[#0f1628] py-16">
          <div className="max-w-3xl mx-auto px-6 text-center">
            <h3 className="font-serif-jp text-white text-2xl tracking-wider mb-4">まずはお気軽にご相談ください</h3>
            <p className="text-white/50 text-sm font-sans mb-8">貴社のニーズに合わせた最適なプランをご提案いたします。</p>
            <Link to="/contact" className="inline-flex items-center gap-2 bg-[#c9a84c] text-[#0f1628] px-10 py-3.5 text-sm tracking-widest font-sans font-medium hover:bg-[#e8c97a] transition-all duration-300 whitespace-nowrap cursor-pointer">
              <i className="ri-mail-send-line"></i>お問い合わせ
            </Link>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
